import React from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { Outlet } from 'react-router-dom';

library.add(fal);

const MainTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const getActiveKey = () => {
    const path = location.pathname;
    if (path.includes('/tools')) return 'tools';
    if (path.includes('/stack')) return 'stack';
    if (path.includes('/mitre')) return 'mitre';
    if (path === '/config') return 'config';
    if (path === '/config/slack') return 'config/slack';
    if (path === '/config/msteams') return 'config/msteams';
    if(path === '/slack' || path === '/msteams' || path === '/notifications' ) return '';
    return 'global';
  };

  const handleTabSelect = (key) => {
    if (key === 'global') {
      navigate('/global/news');
    } else if (key === 'tools') {
      navigate('/tools/news');
    } else if (key === 'stack') {
      navigate('/stack/news');
    } else {
      navigate(`/${key}`);
    }
  };

  return (
    <>
      <Tabs
        defaultActiveKey='global'
        className='nav nav-tabs nav-tabs-top-level'
        activeKey={getActiveKey()}
        onSelect={handleTabSelect}
      >
        <Tab eventKey='global' title='Main Cybersecurity News' />
        <Tab eventKey='tools' title='Cyber Tools' />
        <Tab eventKey='stack' title='IT Environment' />
        <Tab eventKey='mitre' title='Mitre ATT&CK' />
        <Tab
          eventKey='config'
          title={
            <span data-testid='config-menu-gear-icon'>
              <FontAwesomeIcon
                icon={['fal', 'cog']}
                style={{ fontSize: '1.5rem' }}
              />
            </span>
          }
        />
        {/* Hidden tabs for sub-routes */}
        <Tab eventKey='config/slack' title='' tabClassName='hideTab' />
        <Tab eventKey='config/msteams' title='' tabClassName='hideTab' />
      </Tabs>

      <div className='tab-content-wrapper'>
        <Outlet />
      </div>
    </>
  );
};

export default MainTabs;
